export const APPBAR_HEIGHT = 60;
export const SIDEBAR_WIDTH = 60;
/*
 * viewport breakpoints
 */
export const VIEWPORT_BREAKPOINTS = {
    EXTRA_EXTRA_SMALL: 0,
    EXTRA_SMALL: 320,
    SMALL: 768,
    MEDIUM: 1220,
    LARGE: 1920
};
export const Z_INDEXES = {
    HEADER: 80,
    TABLE_HEADER: 90,
    LIGHTBOX: 100,
    CARD: 100,
    MENU: 110,
    OVERLAY: 990
};
